import { skillActions } from '../skills/skill-slice';
import { getData } from '../common-actions';
import { fetchSkills } from '../../lib/api';

export const getSkills = (token, signal) => {

  return getData({
    token: token,
    actions: skillActions,
    fetchFn: (token) => fetchSkills(token, signal),
    dataKey: "skills",
    name: "get skills",
    setFunctionName: "setSkills"
  });
};